export default __webpack_public_path__ + "static/media/nofiles.706a0b20.svg";